import styled from 'styled-components';

export const Container = styled.div`
  margin: -8px;
`;

export const ContentContainer = styled.div`
  margin: 80px 160px;
  text-align: left;
  min-height: 100vh;
`;
